import { reconciliationMessages } from "@/services/messages";
import { toast } from "sonner";

type SuccessAction = "created" | "updated" | "deleted";

/**
 * Единый toast-хелпер для страниц reconciliation (T040a).
 *
 * Все строки берутся из `messages.reconciliation.*` (Constitution VII —
 * никаких string literals). Используется во всех мутирующих хуках TanStack
 * Query через `onError` / `onSuccess` callbacks (FR-019).
 */
export function useReconciliationToasts() {
	return {
		/** Успех мутации — показывает соответствующий toast по action. */
		showSuccess(action: SuccessAction): void {
			switch (action) {
				case "created":
					toast.success(reconciliationMessages.toast_set_created);
					break;
				case "updated":
					toast.success(reconciliationMessages.toast_set_updated);
					break;
				case "deleted":
					toast.success(reconciliationMessages.toast_set_deleted);
					break;
			}
		},

		/** 401 — нет авторизации. */
		showAuthError(): void {
			toast.error(reconciliationMessages.error_auth_required);
		},

		/**
		 * 4xx валидационная ошибка — pre-flight не пройден или форма не валидна.
		 * @param issues — список конкретных проблем (отдельными строками после toast'a).
		 */
		showValidationError(issues?: string[]): void {
			const message = reconciliationMessages.toast_validation_error;
			if (issues && issues.length > 0) {
				toast.error(message, {
					description: issues.join("\n"),
				});
			} else {
				toast.error(message);
			}
		},

		/** Generic API error — показывает сообщение из исключения, либо fallback. */
		showApiError(err: unknown): void {
			const message =
				err instanceof Error && err.message ? err.message : reconciliationMessages.toast_api_error;
			toast.error(message);
		},
	};
}
